import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';

export class WorkCom extends BasicEntity {
comment: string;
naturalUID: string;
obj: string;
params: Object;
parentKey: string;
parentKind: string;
vision: string;
}

